export default __webpack_public_path__ + "static/step-logo-c33bacd50184b1c231530f6e4086db70.png";